import { render, staticRenderFns } from "./ShareTehilim.vue?vue&type=template&id=4956bb2c&scoped=true&"
import script from "./ShareTehilim.vue?vue&type=script&lang=js&"
export * from "./ShareTehilim.vue?vue&type=script&lang=js&"
import style0 from "./ShareTehilim.vue?vue&type=style&index=0&id=4956bb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956bb2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
